import {
    Alert, Box, Paper, Typography, styled,
} from '@mui/material';
import { CancelLoadingButton } from 'src/components/common/buttons/CancelLoadingButton';
import { SaveLoadingButton } from 'src/components/common/buttons/SaveLoadingButton';
import { CONTENT_MAX_WIDTH } from 'src/components/SetsPlayground/constants';

type ProductSetsConfig = Models.IngestConfigApi.SetsConfigs.ProductSetsConfig;

const Footer = styled(Paper)(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: 0,
    zIndex: theme.zIndex.appBar,
}));

// The bar spans the viewport but its contents track the centred content column, so Save and
// Cancel stay aligned with the fields they act on.
const FooterContent = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    margin: '0 auto',
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(4),
}));

interface SetsConfigDetailsFooterProps {
    config: ProductSetsConfig;
    error: string | null;
    hasUnsavedChanges: boolean;
    hasValidationError: boolean;
    isSaving: boolean;
    onCancel: () => void;
    onSave: () => void | Promise<void>;
}

export const SetsConfigDetailsFooter = ({
    config,
    error,
    hasUnsavedChanges,
    hasValidationError,
    isSaving,
    onCancel,
    onSave,
}: SetsConfigDetailsFooterProps): JSX.Element => (
    <Footer elevation={3}>
        <FooterContent>
            <Typography variant="caption">
                {`Last modified by ${config.modifiedBy} on ${new Date(config.modifiedDate).toLocaleString()}`}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                {error && <Alert severity="error">{error}</Alert>}
                <CancelLoadingButton
                    disabled={isSaving || !hasUnsavedChanges}
                    onClick={onCancel}
                >
                    Cancel
                </CancelLoadingButton>
                <SaveLoadingButton
                    disabled={isSaving || !hasUnsavedChanges || hasValidationError}
                    variant="contained"
                    onClick={onSave}
                >
                    Save
                </SaveLoadingButton>
            </Box>
        </FooterContent>
    </Footer>
);
